<div class="flex flex-col">
    <div class="flex justify-between items-end w-full">
      <img src="assets/jarra.webp" alt="DH - Drink Hopping" class="w-[20px]" />
      <img src="assets/vaso.webp" alt="DH - Drink Hopping" class="w-[20px]" />
      <img src="assets/coctel.webp" alt="DH - Drink Hopping" class="w-[20px]" />
    </div>

    <div class="flex justify-between w-full mt-3 mb-2">
      <div class="w-full relative">
        <div class="w-[var(-webkit-fill-available)] h-[8px] mx-[8px]" style="border-top:1px dotted var(--dark-orange)"></div>
        <div class="absolute top-[-50%] left-[5px] w-[8px] h-[8px] bg-[var(--secondary)] rounded-full"></div>
        <div class="absolute left-[calc(50%-4px)] w-[8px] h-[8px] bg-[var(--secondary)] rounded-full" style="top: -50%;"></div>
        <div class="absolute top-[-50%] right-[6px] w-[8px] h-[8px] bg-[var(--secondary)] rounded-full"></div>
      </div>
    </div>

    <div class="flex justify-between w-full">
      <p class="text-[15px]/[17px] uppercase text-left">
        <strong>{{ 'busca.busca' | translate }}</strong> {{ 'busca.tuEvento' | translate }}
      </p>
      <p class="text-[15px]/[17px] uppercase text-center">
        <strong>{{ 'busca.redime' | translate }}</strong> {{ 'busca.tuTicket' | translate }}
      </p>
      <p class="text-[15px]/[17px] uppercase text-right">
        <strong>{{ 'busca.vive' | translate }}</strong> {{ 'busca.elMomento' | translate }}
      </p>
    </div>
  </div>
